interface Solution {
  title: string;
  desc: string;
  icon: string;
}

interface CaseSolutionsProps {
  solutions: Solution[];
}

export default function CaseSolutions({ solutions }: CaseSolutionsProps) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">解决方案</h2>
          <p className="text-lg text-gray-600">针对客户痛点提供的定制化技术方案</p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => {
            const isHtml = solution.desc?.trim().startsWith('<');
            return (
              <div key={index} className="group bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8 hover:shadow-xl transition-all">
                <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${solution.icon || 'ri-lightbulb-line'} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{solution.title}</h3>
                {isHtml ? (
                  <div
                    className="text-gray-700 leading-relaxed prose prose-sm max-w-none"
                    dangerouslySetInnerHTML={{ __html: solution.desc }}
                  />
                ) : (
                  <p className="text-gray-700 leading-relaxed">{solution.desc}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
